"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlankOrInvite = exports.BlankCard = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var mobx_react_1 = require("mobx-react");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var BlankOrInvite = (function (_super) {
    __extends(BlankOrInvite, _super);
    function BlankOrInvite() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shouldShowError = function () {
            var errorMessage = _this.props.errorMessage;
            return errorMessage != null && errorMessage.length > 0;
        };
        return _this;
    }
    BlankOrInvite.prototype.render = function () {
        var _a = this.props, showInvite = _a.showInvite, onClickInvite = _a.onClickInvite, errorMessage = _a.errorMessage;
        return showInvite ? (react_1.default.createElement("div", { className: "blank-or-invite blank-or-invite--invite" },
            react_1.default.createElement("span", { className: "blank-or-invite__invite-text" }, "Invite to account?"),
            react_1.default.createElement(kaleidoscope_2.ErrorTooltip, { renderTooltip: this.shouldShowError(), content: errorMessage || "", position: kaleidoscope_3.TooltipPosition.Top, size: kaleidoscope_3.TooltipSize.Large },
                react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Primary, onClick: onClickInvite }, "Invite")))) : (react_1.default.createElement("div", { className: "blank-or-invite blank-or-invite--blank", onMouseDown: function (event) {
                event.preventDefault();
                event.stopPropagation();
            } },
            react_1.default.createElement(BlankCard, { text: "Enter an email to invite a new user" })));
    };
    BlankOrInvite = __decorate([
        mobx_react_1.observer
    ], BlankOrInvite);
    return BlankOrInvite;
}(react_1.default.Component));
exports.BlankOrInvite = BlankOrInvite;
var BlankCard = function (_a) {
    var text = _a.text;
    return (react_1.default.createElement("div", { className: "blank-or-invite blank-or-invite--blank", onMouseDown: function (event) {
            event.preventDefault();
            event.stopPropagation();
        } },
        react_1.default.createElement("div", { className: "blank-or-invite__blank-text" }, text)));
};
exports.BlankCard = BlankCard;
